// TeraBlues: gerado por scripts/sincronizar-design-system.js a partir de design-system/tokens/tokens.json. Não edite à mão.
// Aliases já resolvidos para o valor final de cada tema.
const tokensTeraBlues = {
  "cores": {
    "light": {
      "azul-900": "#0d47a1",
      "azul-700": "#1976d2",
      "azul-300": "#64b5f6",
      "azul-100": "#bbdefb",
      "branco": "#ffffff",
      "superficie": "#ffffff",
      "superficie-sutil": "#f5f8fc",
      "borda": "#cecece",
      "borda-controle": "#8a8a8a",
      "texto": "#1a1f2b",
      "texto-suave": "#52514e",
      "texto-marca": "#0d47a1",
      "primaria": "#1976d2",
      "primaria-hover": "#0d47a1",
      "sobre-primaria": "#ffffff",
      "barra-fundo": "#1976d2",
      "barra-texto": "#ffffff",
      "barra-contexto": "#bbdefb",
      "perigo": "#c62828",
      "foco": "#0d47a1",
      "foco-sobre-barra": "#ffffff"
    },
    "dark": {
      "azul-900": "#0d47a1",
      "azul-700": "#1976d2",
      "azul-300": "#64b5f6",
      "azul-100": "#bbdefb",
      "branco": "#ffffff",
      "superficie": "#0b1220",
      "superficie-sutil": "#121b2e",
      "borda": "#24324a",
      "borda-controle": "#5a6b85",
      "texto": "#e6edf7",
      "texto-suave": "#a9b6c8",
      "texto-marca": "#bbdefb",
      "primaria": "#64b5f6",
      "primaria-hover": "#bbdefb",
      "sobre-primaria": "#0b1220",
      "barra-fundo": "#1976d2",
      "barra-texto": "#ffffff",
      "barra-contexto": "#bbdefb",
      "perigo": "#ef9a9a",
      "foco": "#bbdefb",
      "foco-sobre-barra": "#ffffff"
    }
  },
  "espaco": {
    "espaco-1": "4px",
    "espaco-2": "8px",
    "espaco-3": "12px",
    "espaco-4": "16px",
    "espaco-6": "24px",
    "espaco-8": "32px",
    "espaco-12": "48px"
  },
  "raio": {
    "raio-sm": "4px",
    "raio-lg": "12px",
    "raio-icone": "22%",
    "raio-pilula": "9999px"
  },
  "tamanho": {
    "barra-altura": "56px",
    "controle-altura": "40px"
  },
  "fontes": {
    "sans": "\"Segoe UI\", system-ui, -apple-system, \"Helvetica Neue\", Arial, sans-serif"
  },
  "textos": {
    "display": {
      "fontFamily": "\"Segoe UI\", system-ui, -apple-system, \"Helvetica Neue\", Arial, sans-serif",
      "fontSize": "40px",
      "lineHeight": "44px",
      "fontWeight": 600,
      "letterSpacing": "-0.01em"
    },
    "titulo-1": {
      "fontFamily": "\"Segoe UI\", system-ui, -apple-system, \"Helvetica Neue\", Arial, sans-serif",
      "fontSize": "28px",
      "lineHeight": "36px",
      "fontWeight": 600
    },
    "titulo-2": {
      "fontFamily": "\"Segoe UI\", system-ui, -apple-system, \"Helvetica Neue\", Arial, sans-serif",
      "fontSize": "20px",
      "lineHeight": "28px",
      "fontWeight": 600
    },
    "corpo": {
      "fontFamily": "\"Segoe UI\", system-ui, -apple-system, \"Helvetica Neue\", Arial, sans-serif",
      "fontSize": "15px",
      "lineHeight": "22px",
      "fontWeight": 400
    },
    "corpo-forte": {
      "fontFamily": "\"Segoe UI\", system-ui, -apple-system, \"Helvetica Neue\", Arial, sans-serif",
      "fontSize": "15px",
      "lineHeight": "22px",
      "fontWeight": 600
    },
    "legenda": {
      "fontFamily": "\"Segoe UI\", system-ui, -apple-system, \"Helvetica Neue\", Arial, sans-serif",
      "fontSize": "13px",
      "lineHeight": "18px",
      "fontWeight": 400
    },
    "barra-marca": {
      "fontFamily": "\"Segoe UI\", system-ui, -apple-system, \"Helvetica Neue\", Arial, sans-serif",
      "fontSize": "20px",
      "lineHeight": "28px",
      "fontWeight": 600
    },
    "barra-contexto": {
      "fontFamily": "\"Segoe UI\", system-ui, -apple-system, \"Helvetica Neue\", Arial, sans-serif",
      "fontSize": "16px",
      "lineHeight": "24px",
      "fontWeight": 400
    },
    "barra-usuario": {
      "fontFamily": "\"Segoe UI\", system-ui, -apple-system, \"Helvetica Neue\", Arial, sans-serif",
      "fontSize": "15px",
      "lineHeight": "22px",
      "fontWeight": 400
    }
  }
};

export default tokensTeraBlues;
